/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";

import {
  MapContainer,
  Marker,
  Polyline,
  Popup,
  TileLayer,
  useMap,
} from "react-leaflet";

import {
  faCar,
  faCheck,
  faCheckDouble,
  faCircle,
  faComment,
  faCommentDots,
  faComments,
  faInfo,
  faRobot,
  faSackDollar,
  faStar,
  faTaxi,
  faUser,
  faUserSlash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminRoute from "../../../auth/RestrictedRoute";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CCloseButton,
  CContainer,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  CSpinner,
} from "@coreui/react";

import "leaflet-routing-machine";
import Skeleton from "react-loading-skeleton";
import { Link, useParams } from "react-router-dom";
import BoxWrapper from "../../../../components/BoxWrapper";
import {
  decodePolyline,
  formatDateString,
  formatRelativeTime,
  isEmpty,
  isNotEmpty,
  paymentMethodHelper,
} from "../../../../helpers/general";

import { format } from "date-fns";
import { divIcon, LatLng, LatLngBounds, LatLngTuple } from "leaflet";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { SidebarIcon } from "../../../../components/icons/SidebarIcons";
import PromptModal from "../../../../components/modals/PromptModal";
import MoroccanLicensePlate from "../../../../components/taxi/moroccan_license_plate";
import { apiConfig } from "../../../../config/apiConfig";
import { getBadgeClassNameByStatus } from "../../../../helpers/colors";
import {
  RidecancelReasonLabels,
  RideStatus,
  RideStatusLabels,
} from "../../../../helpers/enums";
import { useCookie } from "../../../../hooks/useCookie";
import { useToast } from "../../../../hooks/useToast";
import { general } from "../../../../locales/general";
import apiService from "../../../../service/apiService";
import RideHistoryTimeline from "../../../../components/taxi/RidesActionsDetails";
import { GeoJSON } from "react-leaflet";
import { cityBoundaries, cityStyle } from "../../../../helpers/constants";
import { ProfilePictureAvatar } from "../../../../components/taxi/Profile_picture_avatar";
import InternalCommentsModal from "../../../../components/modals/InternalCommentsModal";
import ReactLeafletDriftMarker from "react-leaflet-drift-marker";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  onSnapshot,
  doc as firebaseDocument,
  getDoc,
} from "firebase/firestore";
import L from "leaflet";
import TaxiDetails from "../../AllTaxi/TaxiDetails";

const ONE_KILOMETER = 1000;
function metersToKilometers(meters: number): number {
  return meters < ONE_KILOMETER ? meters : meters / ONE_KILOMETER;
}

// function FitBounds({ bounds }: { bounds: LatLngBounds }) {
//   const map = useMap();
//   useEffect(() => {
//     map.fitBounds(bounds);
//   }, [map]);
//   return null;
// }

const startIconSvg = `
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.0729 27.1293C21.3367 27.1293 27.2252 21.2409 27.2252 13.977C27.2252 6.7132 21.3367 0.824707 14.0729 0.824707C6.80903 0.824707 0.920532 6.7132 0.920532 13.977C0.920532 21.2409 6.80903 27.1293 14.0729 27.1293Z" fill="white"/>
<path d="M14.073 23.8413C19.5208 23.8413 23.9372 19.4249 23.9372 13.977C23.9372 8.52916 19.5208 4.11279 14.073 4.11279C8.62511 4.11279 4.20874 8.52916 4.20874 13.977C4.20874 19.4249 8.62511 23.8413 14.073 23.8413Z" stroke="url(#paint0_linear_1719_23049)" stroke-width="6.57616"/>
<defs>
<linearGradient id="paint0_linear_1719_23049" x1="4.6327" y1="5.3033" x2="24.415" y2="5.82797" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF7722"/>
<stop offset="1" stop-color="#FFB800"/>
</linearGradient>
</defs>
</svg>

`;

const endIconSvg = `
<svg width="21" height="27" viewBox="0 0 21 27" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.3215 26.4107C9.27921 26.4107 4.32736 20.2893 3.11406 18.3198C1.30452 15.3759 0.208496 13.5981 0.208496 10.2191C0.208496 7.53676 1.27403 4.96433 3.1707 3.06767C5.06736 1.171 7.63979 0.105469 10.3221 0.105469C13.0044 0.105469 15.5768 1.171 17.4735 3.06767C19.3701 4.96433 20.4357 7.53676 20.4357 10.2191C20.4357 13.4622 19.355 15.2136 17.5652 18.117L17.4413 18.3187C16.1908 20.3452 11.3441 26.4107 10.3215 26.4107ZM10.3215 5.16308C9.32134 5.16308 8.34361 5.45968 7.51198 6.01535C6.68035 6.57103 6.03217 7.36084 5.64941 8.28489C5.26666 9.20895 5.16651 10.2258 5.36164 11.2067C5.55676 12.1877 6.0384 13.0888 6.74565 13.796C7.45289 14.5033 8.35397 14.9849 9.33495 15.18C10.3159 15.3752 11.3327 15.275 12.2568 14.8923C13.1808 14.5095 13.9707 13.8613 14.5263 13.0297C15.082 12.1981 15.3786 11.2203 15.3786 10.2201C15.3771 8.87938 14.8439 7.59394 13.8958 6.64587C12.9477 5.6978 11.6623 5.16453 10.3215 5.16308Z" fill="#22AAFF"/>
</svg>
`;

function RideDetailsPage() {
  const params = useParams();
  const [route, setRoute] = useState<LatLngTuple[]>([]);
  const [driverRoute, setdriverRoute] = useState<LatLngTuple[]>([]);
  const [userRoute, setUserRoute] = useState<LatLngTuple[]>([]);
  const [showSuggestedRoute, setShowSuggestedRoute] = useState(true);
  const [showDriverRoute, setShowDriverRoute] = useState(true);
  const [showUserRoute, setShowUserRoute] = useState(true);
  const [showUpdateConfirm, setShowUpdateConfirm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<RideStatus | string>("");
  const [hasInitiallyFittedBounds, setHasInitiallyFittedBounds] =
    useState(false);

  const [foundDrivers, setFoundDrivers] = useState<RideDriverLog[]>([]);
  const [showDriversOnMap, setShowDriversOnMap] = useState<
    Record<string, boolean>
  >({});
  const [showInternalComments, setShowInternalComments] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [driverPingStaleTimeout, setDriverPingStaleTimeout] =
    useState<MilliSeconds>(90000);
  const [taxis, setTaxis] = useState<FireStoreDriverLocation[]>([]);
  const [selectedTaxi, setSelectedTaxi] =
    useState<FireStoreDriverLocation | null>(null);
  const [showDetails, setShowDetails] = useState(false);

  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  };

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, process.env.REACT_APP_FIREBASE_FIRESTORE_DB!),
      (snapshot) => {
        const docs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        const taxiData: any = docs.filter(
          (t: any) => t.curr_loc?.latitude && t.curr_loc?.longitude,
        );
        setTaxis(taxiData);
      },
    );
    const configDocRef = firebaseDocument(
      db,
      process.env.REACT_APP_TAXI_CONFIG_FIRESTORE_DOC!,
    );
    getDoc(configDocRef).then((doc) => {
      const data = doc.data();
      if (data) {
        setDriverPingStaleTimeout(data.driverPingStale_ms);
      }
    });

    return () => unsubscribe();
  }, []);

  const filteredTaxis = useMemo(() => {
    return taxis.filter(
      (taxi) =>
        taxi.isOnline &&
        taxi.ping_timestamp.seconds * 1000 >
          Date.now() - driverPingStaleTimeout,
    );
  }, [taxis]);

  const endpoint = apiConfig.rides.get(params?.rideId!);
  const { token } = useCookie("vToken");

  const { data: ride, isLoading } = useQuery<Ride>(
    [endpoint, token, params?.rideId],
    () => apiService.MakeGetRequest(endpoint, token),
    {
      refetchInterval: (data) => {
        if (!data) return false;
        return ["searching_for_drivers", "waiting_pickup", "on_going"].includes(
          data.status,
        )
          ? 3000
          : false;
      },
    },
  );

  const queryClient = useQueryClient();
  const { toastError, toastSuccess } = useToast();

  const validatedRide = useMutation({
    mutationFn: (data: { endpoint: string }) =>
      apiService.MakePutRequest(data.endpoint, {}, token),
  });

  const updateRideMutation = useMutation({
    mutationFn: (data: { endpoint: string; status: string }) =>
      apiService.MakePutRequest(
        data.endpoint,
        {
          status: data.status,
        },
        token,
      ),
  });

  useEffect(() => {
    if (!ride) return;
    const encodedPath = ride?.suggestedRoute;
    const decodedPath = decodePolyline(encodedPath);

    interface LocationData {
      lat: number;
      lng: number;
    }
    const actualDriverRoute = ride?.history

      .filter(
        (h) =>
          h.type === "driver_log" ||
          (h.data.type == "action" &&
            // h.data.action === "start_ride" ||
            (h.data.action === "complete_ride" ||
              // h.data.action === "arrived_at_pickup" ||
              h.data.action === "driver_cancel_ride")),
      )
      .filter(
        (h: any) =>
          typeof h.data === "object" &&
          h.data !== null &&
          Number.isFinite(h.data?.lat) &&
          Number.isFinite(h.data?.lng),
      )
      .sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      )
      .map((h) => {
        const locationData = h.data as LocationData;
        return [locationData.lat, locationData.lng] as LatLngTuple;
      });

    const actualUserRoute = ride.history

      .filter(
        (h) =>
          h.type === "user_log" ||
          (h.data.type == "action" && h.data.action === "user_cancel_ride"),
      )
      .filter(
        (h: any) =>
          typeof h.data === "object" &&
          h.data !== null &&
          Number.isFinite(h.data?.lat) &&
          Number.isFinite(h.data?.lng),
      )
      .sort(
        (a, b) =>
          new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
      )
      .map((h) => {
        const locationData = h.data as LocationData;
        return [locationData.lat, locationData.lng] as LatLngTuple;
      });

    setRoute(decodedPath);
    setdriverRoute(actualDriverRoute);
    setUserRoute(actualUserRoute);
    // setHasInitiallyFittedBounds(false);
  }, [ride]);

  const specialZone = useMemo(() => {
    if (!ride?.usedSpecialZone) return null;
    return {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [decodePolyline(ride.usedSpecialZone.overviewPolyline)],
      },
    };
  }, [ride?.usedSpecialZone]);

  if (!ride && !isLoading) {
    return <div>Trajet non trouvée</div>;
  }
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <CSpinner size="sm" color="success" />
      </div>
    );
  }

  const startIcon = divIcon({
    html: startIconSvg,
    className: "",
    iconSize: [21, 27],
    iconAnchor: [10.5, 27],
  });

  const endIcon = divIcon({
    html: endIconSvg,
    className: "",
    iconSize: [21, 27],
    iconAnchor: [10.5, 27],
  });

  // const statusMapping: { [key: string]: string } = {
  //   completed: "Terminé",
  //   pending: "En attente",
  //   user_cancelled: "Annulé par l'utilisateur",
  //   driver_cancelled: "Annulé par le conducteur",
  //   admin_cancelled: "Annulé par l'administrateur",
  //   no_driver_found: "Aucun conducteur trouvé",
  // };

  const readableSource = (source?: string) => {
    if (
      source === "current-position" ||
      source === "map-search-current-position"
    )
      return "(Position actuelle de l'utilisateur)";
    if (source === "text-search")
      return "(L'adresse a été recherchée par l'utilisateur)";
    if (source === "map-search-picker" || source === "picker")
      return "(L'adresse a été sélectionnée sur la carte)";
    if (source === "saved-address")
      return "(L'adresse a été sauvegardée par l'utilisateur)";
    if (source === "initial-position") return "(Position initiale ⚠️)";
  };

  const validStatusOptions = [
    {
      value: RideStatus.COMPLETED,
      label: RideStatusLabels[RideStatus.COMPLETED],
    },
    {
      value: RideStatus.USER_CANCELLED,
      label: RideStatusLabels[RideStatus.USER_CANCELLED],
    },
    {
      value: RideStatus.DRIVER_CANCELLED,
      label: RideStatusLabels[RideStatus.DRIVER_CANCELLED],
    },
    {
      value: RideStatus.ADMIN_CANCELLED,
      label: RideStatusLabels[RideStatus.ADMIN_CANCELLED],
    },
  ];

  // const displayStatus = statusMapping[ride.status] || ride.status;

  const changeRideStatus = async (setValid: boolean) => {
    try {
      // const isValid = !!ride?.metaData?.validRide;
      const rideId = params?.rideId as string;
      const endpoint = setValid
        ? apiConfig.rides.invalid_ride(rideId)
        : apiConfig.rides.valid_ride(rideId);
      await validatedRide.mutateAsync({ endpoint });
      queryClient.invalidateQueries();
      toastSuccess(general.fr.message.rideStatusChanged);
    } catch (error) {
      toastError(general.fr.message.operationFailed);
    }
  };

  const onUpdateInternalComments = async (comments: string) => {
    try {
      const rideId = params?.rideId as string;
      const endpoint = apiConfig.rides.update_internal_comments(rideId);
      await apiService.MakePutRequest(endpoint, { comments }, token);
    } catch (error) {
      toastError(general.fr.message.operationFailed);
    }
  };

  const handleConfirmStatusUpdate = async () => {
    try {
      const rideId = params?.rideId as string;
      const endpoint = apiConfig.rides.update_ride(rideId);
      await updateRideMutation.mutateAsync({
        endpoint,
        status: selectedStatus,
      });
      queryClient.invalidateQueries();
      const statusLabel =
        RideStatusLabels[selectedStatus as keyof typeof RideStatusLabels];
      toastSuccess(`Statut du trajet mis à jour en ${statusLabel}`);
    } catch (error) {
      toastError(general.fr.message.operationFailed);
    } finally {
      setShowUpdateConfirm(false);
    }
  };

  const updateRideStatus = (status: RideStatus | string) => {
    setSelectedStatus(status);
    setShowUpdateConfirm(true);
  };

  const chats = ride.history
    .filter((item) => item.type === "chat")
    .map((item) => {
      // Get the data from inside the item
      const chatData = item.data as unknown as RideChat;
      const chatMessage: RideConversation = {
        id: item.id,
        type: chatData.type,
        sender: chatData.sender || "",
        data: chatData.data || "",
        dateTime: item.createdAt,
        isSeen: Boolean(chatData.seen),
        driver: {
          fullName: ride.driver?.fullName,
          profilePicture: ride.driver?.profilePicture,
        },
        user: {
          fullName: ride.user?.fullName ?? " ",
          profilePicture: ride.user?.profilePicture,
        },
        isSystem: Boolean(chatData.isSystem),
      };

      return chatMessage;
    });

  const cancelItem = ride.history.find(
    (item) =>
      item.type === "action" &&
      item.data?.type === "action" &&
      "action" in item.data &&
      (item.data.action === "user_cancel_ride" ||
        item.data.action === "driver_cancel_ride"),
  );

  let reasonLabel = "";

  if (cancelItem && "reason" in cancelItem.data && cancelItem.data.reason) {
    if (cancelItem.data.action === "driver_cancel_ride") {
      reasonLabel = cancelItem.data.reason;
    } else if (cancelItem.data.action === "user_cancel_ride") {
      reasonLabel =
        RidecancelReasonLabels[
          cancelItem.data.reason as keyof typeof RidecancelReasonLabels
        ] ?? "";
    }
  }

  const rideCreationTime = new Date(ride.createdAt);
  const cancelTime = new Date(cancelItem?.createdAt!);
  const durationMs = cancelTime.getTime() - rideCreationTime.getTime();
  // const totalSeconds = Math.floor(durationMs / 1000);
  // const minutes = Math.floor(totalSeconds / 60);
  // const seconds = totalSeconds % 60;

  function FitBounds({
    bounds,
    onFitted,
  }: {
    bounds: LatLngBounds;
    onFitted?: () => void;
  }) {
    const map = useMap();
    useEffect(() => {
      map.fitBounds(bounds);
      onFitted?.();
    }, [map, bounds, onFitted]);
    return null;
  }

  const handleTaxiClick = (taxi: FireStoreDriverLocation) => {
    setSelectedTaxi(taxi);
    setShowDetails(true);
  };

  console.log(filteredTaxis);
  console.log(ride.status);

  return (
    <AdminRoute>
      <section className="bg-blue">
        <h5 className="fs-4 fw-bold mb-2">Détails du trajet</h5>
        <BoxWrapper className="bg-black">
          <CContainer fluid>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div className=" align-items-center w-100">
                <CDropdown alignment={"start"} className="p-0">
                  <div className="d-flex align-items-cente flex-column gap-">
                    <div className="d-flex justify-content-start gap-3">
                      <div className="d-flex align-items-center gap-2">
                        <button
                          className="btn rounded-sm py-2 px-3 position-relative"
                          style={{ backgroundColor: "#ff772264" }}
                          onClick={() => setShowInternalComments(true)}
                        >
                          <FontAwesomeIcon
                            icon={faCommentDots}
                            className="p-1 text-danger"
                          />
                          {ride.internalComments &&
                            ride.internalComments.trim() !== "" && (
                              <span
                                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  padding: "0",
                                  fontSize: "0",
                                }}
                              >
                                <span className="visually-hidden">
                                  A des commentaires
                                </span>
                              </span>
                            )}
                        </button>
                        <InternalCommentsModal
                          open={showInternalComments}
                          onClose={() => setShowInternalComments(false)}
                          onUpdateInternalComments={async (
                            comments: string,
                          ) => {
                            await onUpdateInternalComments(comments);
                            setShowInternalComments(false);
                          }}
                          initialInternalComments={ride.internalComments || ""}
                        />
                      </div>
                      <span
                        //  className={getBadgeClassNameByStatus(ride.status)}
                        className={
                          ride.status === RideStatus.WAITING_PICKUP
                            ? "badge-primary"
                            : getBadgeClassNameByStatus(ride.status)
                        }
                      >
                        <CDropdownToggle
                          color={getBadgeClassNameByStatus(ride.status)}
                        >
                          {
                            RideStatusLabels[
                              ride.status as keyof typeof RideStatusLabels
                            ]
                          }
                        </CDropdownToggle>
                      </span>
                      <div className="text-medium-emphasis  m-auto  ">
                        {formatDateString(ride.createdAt)} -{" "}
                        {format(new Date(ride.createdAt), "HH:mm")}
                      </div>
                    </div>

                    <div className="ps-2 mb-2">
                      {/* <span className="fw-bold">Motif : </span> */}
                      {reasonLabel && (
                        <span>
                          <strong>Motif :</strong> {reasonLabel}
                        </span>
                      )}
                      {cancelItem && (
                        <div>
                          <strong>
                            Temps avant annulation :{" "}
                            <span className="fs-4">⏱️</span>
                          </strong>{" "}
                          {formatRelativeTime(durationMs)} après
                          {/* {minutes} min {seconds} sec */}
                        </div>
                      )}
                    </div>
                  </div>

                  <CDropdownMenu>
                    {validStatusOptions.map(({ value, label }) => (
                      <CDropdownItem
                        style={{ cursor: "pointer" }}
                        key={value}
                        onClick={() => updateRideStatus(value)}
                      >
                        {ride.status === value ? (
                          <FontAwesomeIcon
                            icon={faCheck}
                            className="me-2 text-success"
                          />
                        ) : (
                          <span className="me-4"></span>
                        )}
                        {label}
                      </CDropdownItem>
                    ))}
                  </CDropdownMenu>
                </CDropdown>
              </div>

              <div className="d-flex flex-column w-25">
                {ride.status === "completed" && (
                  <>
                    {isEmpty(ride.metaData?.validRide) ? (
                      <div className="d-flex flex-column align-items-center pt-2 ">
                        <div className=" text-center">
                          <span className="fs-5 fw-bold text-secondary">
                            Validation du trajet
                          </span>
                        </div>
                        <div className="d-flex gap-1 justify-content-center">
                          <button
                            className="btn bg-white rounded-sm py-1  text-black mt-1 me-3 border border-3 border-black  "
                            disabled={validatedRide.isLoading}
                            // onClick={changeRideStatus}
                            onClick={() => changeRideStatus(true)}
                          >
                            <span className="me-2">❌</span>
                            Non Valide
                          </button>
                          <button
                            className="btn bg-white rounded-sm py-1  text-black mt-1 border border-3 border-black "
                            disabled={validatedRide.isLoading}
                            // onClick={changeRideStatus}
                            onClick={() => changeRideStatus(false)}
                          >
                            <span className="me-2">✅</span>
                            Valide
                          </button>
                        </div>
                      </div>
                    ) : (
                      // Existing metadata state
                      <div className="d-flex flex-column align-items-center pt-2 ">
                        <div className="d-flex justify-content-between align-items-center gap-4 pb-2">
                          <span
                            className={`fs-5 fw-bold ${
                              ride.metaData?.validRide
                                ? "text-success"
                                : "text-red"
                            }`}
                          >
                            {ride.metaData?.validRide ? (
                              <>
                                <span className="me-2">✅</span>
                                Trajet Valide
                              </>
                            ) : (
                              <>
                                <span className="me-2">❌</span>
                                Trajet Non Valide
                              </>
                            )}
                          </span>
                        </div>
                        <button
                          className={
                            "btn bg-white rounded-sm py-2 px-4 text-black border border-3 border-black "
                          }
                          disabled={validatedRide.isLoading}
                          // onClick={changeRideStatus}

                          onClick={
                            ride.metaData?.validRide
                              ? () => changeRideStatus(true)
                              : () => changeRideStatus(false)
                          }
                        >
                          {ride.metaData?.validRide ? (
                            <>Marquer comme non valide</>
                          ) : (
                            <>Marquer comme valide</>
                          )}
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Left Column - Map and Route */}

            <div className="d-flex gap-4  ride-table-info-wrapper w-100 ">
              <CCard className="mb-4 w-100">
                <CCardHeader className="bg-gradient-primary">
                  <div className="d-flex align-items-center text-white">
                    {/* <CIcon icon={cilLocationPin} className="me-2" /> */}
                    <FontAwesomeIcon icon={faCar} className="me-2" />
                    Informations sur le trajet
                  </div>
                </CCardHeader>
                <CCardBody>
                  <div
                    className="bg-light  text-center mb-4 w-100"
                    style={{ height: "450px" }}
                  >
                    <MapContainer
                      center={[30.427755, -9.598107]}
                      zoom={13}
                      style={{ height: "100%", width: "100%", zIndex: 40 }}
                    >
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                      />
                      <GeoJSON data={cityBoundaries} style={cityStyle} />
                      {specialZone && (
                        <GeoJSON data={specialZone as any}>
                          <Popup>
                            <div className="py-2 px-4 d-flex flex-column gap-2">
                              <div className="fw-semibold text-center d-flex flex-column justify-content-center align-content-center">
                                {ride?.usedSpecialZone?.name} (+
                                {ride?.usedSpecialZone?.price} DH)
                              </div>
                            </div>
                          </Popup>
                        </GeoJSON>
                      )}

                      {(route.length > 0 ||
                        driverRoute.length > 0 ||
                        userRoute.length > 0) &&
                        !hasInitiallyFittedBounds && (
                          <FitBounds
                            bounds={
                              new LatLngBounds(
                                [...route, ...driverRoute, ...userRoute].map(
                                  (coord) => new LatLng(coord[0], coord[1]),
                                ),
                              )
                            }
                            onFitted={() => setHasInitiallyFittedBounds(true)}
                          />
                        )}
                      {route.length > 0 && showSuggestedRoute && (
                        <>
                          <Polyline
                            positions={route}
                            color="#FF7722"
                            weight={3}
                          />
                          <Marker position={route[0]} icon={startIcon} />
                          <Marker
                            position={route[route.length - 1]}
                            icon={endIcon}
                          />
                        </>
                      )}

                      {driverRoute.length > 0 && showDriverRoute && (
                        <>
                          <Polyline
                            positions={driverRoute}
                            color="#22aaff"
                            weight={3}
                          />
                          <Marker position={driverRoute[0]} icon={startIcon} />
                          <Marker
                            position={driverRoute[driverRoute.length - 1]}
                            icon={endIcon}
                          />
                        </>
                      )}

                      {userRoute.length > 0 && showUserRoute && (
                        <>
                          <Polyline
                            positions={userRoute}
                            color="#CC5500"
                            weight={3}
                          />
                          <Marker position={userRoute[0]} icon={startIcon} />
                          <Marker
                            position={userRoute[userRoute.length - 1]}
                            icon={endIcon}
                          />
                        </>
                      )}

                      {ride.status === RideStatus.SEARCHING_FOR_DRIVERS && (
                        <>
                          {filteredTaxis.map((taxi) => (
                            <ReactLeafletDriftMarker
                              key={taxi?.id}
                              position={{
                                lat: taxi?.curr_loc?.latitude,
                                lng: taxi?.curr_loc?.longitude,
                              }}
                              icon={L.divIcon({
                                className: "custom-icon",
                                html: `
            <div style="transform: rotate(${taxi?.rotation || 0}deg)">
              <img src="/taxi_red_map_icon.png" width="25" height="35"/>
            </div>
          `,
                                iconAnchor: [12.5, 90],
                              })}
                              duration={3000}
                              eventHandlers={{
                                click: (e) => {
                                  e.originalEvent.stopPropagation();
                                  handleTaxiClick(taxi);
                                },
                              }}
                            >
                              <Popup>
                                {taxi?.isOnline ? "En ligne" : "Hors connexion"}
                              </Popup>
                            </ReactLeafletDriftMarker>
                          ))}
                        </>
                      )}

                      {/* Driver markers for selected drivers */}
                      {foundDrivers
                        .filter(
                          (driverLog) => showDriversOnMap[driverLog.driver.id],
                        )
                        .map((driverLog) => (
                          <Marker
                            key={driverLog.driver.id}
                            position={[driverLog.lat, driverLog.lng]}
                            icon={divIcon({
                              html: `<div style="transform: rotate(0deg)">
                 <img src="/taxi_red_map_icon.png" width="25" height="35"/>
               </div>`,
                              className: "custom-driver-icon",
                              iconSize: [25, 35],
                              iconAnchor: [12.5, 35],
                            })}
                          >
                            <Popup>
                              <div>
                                <span className="fw-bold">
                                  {driverLog.driver.fullName}
                                  <span className="ms-2">
                                    {driverLog.isOnline ? (
                                      <FontAwesomeIcon
                                        icon={faCircle}
                                        className="text-success"
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={faCircle}
                                        className="text-red"
                                      />
                                    )}
                                  </span>
                                </span>
                                <br />
                                <small>
                                  Rayon:{" "}
                                  {driverLog.radius < ONE_KILOMETER
                                    ? driverLog.radius + "m"
                                    : (
                                        driverLog.radius / ONE_KILOMETER
                                      ).toFixed(1) + "Km"}
                                </small>
                              </div>
                            </Popup>
                          </Marker>
                        ))}
                    </MapContainer>

                    <COffcanvas
                      placement="start"
                      visible={showDetails}
                      onHide={() => setShowDetails(false)}
                      backdrop={false}
                      scroll={true}
                    >
                      <COffcanvasHeader>
                        <h5>Détails du taxi</h5>
                        <CCloseButton
                          className="text-reset"
                          onClick={() => setShowDetails(false)}
                        />
                      </COffcanvasHeader>
                      <COffcanvasBody>
                        {selectedTaxi ? (
                          <TaxiDetails selectedTaxi={selectedTaxi} />
                        ) : null}
                      </COffcanvasBody>
                    </COffcanvas>
                    <div className="d-flex justify-content-end align-items-center gap-3 mb-2 mt-2 ">
                      <div className="form-check d-flex align-items-center">
                        <input
                          id="suggested-route"
                          type="checkbox"
                          className="form-check-input me-2"
                          checked={showSuggestedRoute}
                          onChange={(e) =>
                            setShowSuggestedRoute(e.target.checked)
                          }
                        />

                        <label
                          htmlFor="suggested-route"
                          className="form-check-label"
                        >
                          <SidebarIcon.RidesSVG
                            className="me-2"
                            fill="#FF7722"
                          />
                          Itinéraire suggéré
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          id="driver-route"
                          type="checkbox"
                          className="form-check-input me-2"
                          checked={showDriverRoute}
                          onChange={(e) => setShowDriverRoute(e.target.checked)}
                        />

                        <label
                          htmlFor="driver-route"
                          className="form-check-label"
                        >
                          <SidebarIcon.RidesSVG
                            className="me-2"
                            fill="#22aaff"
                          />
                          Itinéraire du conducteur
                        </label>
                      </div>

                      <div className="form-check d-flex align-items-center">
                        <input
                          id="user-route"
                          type="checkbox"
                          className="form-check-input me-2"
                          checked={showUserRoute}
                          onChange={(e) => setShowUserRoute(e.target.checked)}
                        />

                        <label
                          htmlFor="user-route"
                          className="form-check-label"
                        >
                          <SidebarIcon.RidesSVG
                            className="me-2"
                            fill="#CC5500"
                          />
                          Itinéraire utilisateur
                        </label>
                      </div>
                    </div>
                  </div>

                  <div style={{ marginTop: "50px" }}>
                    <div className="mb-3 ">
                      <span
                        dangerouslySetInnerHTML={{ __html: startIconSvg }}
                        style={{ marginRight: "2px" }}
                      />
                      <small className="text-medium-emphasis">
                        {" "}
                        Point de départ{" "}
                        {readableSource(ride.pickupLocation.source)}
                      </small>
                      <div className="fw-medium">{ride.pickupLocationName}</div>
                    </div>
                    <div>
                      <span
                        dangerouslySetInnerHTML={{ __html: endIconSvg }}
                        style={{ marginRight: "2px" }}
                      />
                      <small className="text-medium-emphasis">
                        Point destination{" "}
                        {readableSource(ride.destinationLocation.source)}
                      </small>
                      <div className="fw-medium">
                        {ride.destinationLocationName}
                      </div>
                    </div>
                  </div>
                </CCardBody>
              </CCard>

              <RideHistoryTimeline
                ride={ride}
                onFoundDriversChange={setFoundDrivers}
                onShowDriversOnMapChange={setShowDriversOnMap}
              />
            </div>

            <div className="d-flex gap-4  ride-table-info-wrapper  ">
              <CCard className="mb-4 flex-grow-1" style={{ flex: 1 }}>
                <CCardHeader className="d-flex justify-content-between  bg-gradient-primary text-white">
                  <span>
                    <FontAwesomeIcon icon={faInfo} className="me-2" />
                    Informations sur le trajet
                  </span>
                </CCardHeader>

                <CCardBody>
                  <div className="d-flex justify-content-between mb-2 flex-wrap">
                    <div
                      className="d-flex align-items-center text-bold "
                      style={{ fontSize: "1.1rem" }}
                    >
                      Duration
                    </div>
                    <span className="text-bold " style={{ fontSize: "1.1rem" }}>
                      {ride.estimatedDuration
                        ? Math.floor(ride.estimatedDuration / 60)
                        : ""}{" "}
                      min
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2 flex-wrap">
                    <div
                      className="d-flex align-items-center text-bold "
                      style={{ fontSize: "1.1rem" }}
                    >
                      Distance
                    </div>
                    <span className="text-bold " style={{ fontSize: "1.1rem" }}>
                      {metersToKilometers(ride.distance).toFixed(2)}{" "}
                      {ride.distance < ONE_KILOMETER ? "m" : "Km"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2 flex-wrap">
                    <div
                      className="d-flex align-items-center text-bold "
                      style={{ fontSize: "1.1rem" }}
                    >
                      Prix
                    </div>
                    <div className="text-end">
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {ride.fare} MAD
                      </span>
                      {ride.fare !== ride.originalFare && (
                        <div className="text-muted text-decoration-line-through">
                          {ride.originalFare} MAD
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between mb-2 flex-wrap">
                    <small
                      className="d-flex align-items-center text-bold "
                      style={{ fontSize: "1.1rem" }}
                    >
                      Mode de paiement{" "}
                    </small>
                    <span className="text-bold " style={{ fontSize: "1.1rem" }}>
                      {paymentMethodHelper(ride?.paymentMethod)}
                    </span>
                  </div>
                  {isNotEmpty(ride?.usedSpecialZone) && (
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <small
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {" "}
                        Zone spéciale{" "}
                      </small>
                      <div className="text-end">
                        <div>
                          <span
                            className="text-bold"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {ride?.usedSpecialZone?.name} (+
                            {ride?.usedSpecialZone?.price} DH)
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  {ride?.priceCalculation?.coupon?.isCouponApplied === true ? (
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <small
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {" "}
                        Coupon{" "}
                      </small>
                      <div className="text-end">
                        <div>
                          <span
                            className="text-bold"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {ride.appliedCoupon.name}{" "}
                            <span>
                              (-
                              {ride?.priceCalculation?.coupon?.couponPercentage}
                              %)
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {ride?.metaData?.couponDiscount?.paid ? (
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <small
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Le coupon payé
                      </small>
                      <div className="text-end">
                        <div>
                          <span
                            className="text-bold"
                            style={{ fontSize: "1.1rem" }}
                          >
                            ✅
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </CCardBody>

                <CCardHeader className="bg-gradient-primary text-white">
                  <FontAwesomeIcon icon={faSackDollar} className="me-2" />
                  Informations sur le prelevement
                </CCardHeader>
                <CCardBody>
                  <div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Total commission
                      </div>
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {ride.status === "completed"
                          ? (
                              ride.priceCalculation.calculation
                                .balanceCommission +
                              ride.priceCalculation.calculation.balanceTVA
                            ).toFixed(2)
                          : "0"}{" "}
                        MAD
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Frais de service
                      </div>
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {ride.status === "completed"
                          ? ride.priceCalculation.calculation.balanceCommission.toFixed(
                              2,
                            )
                          : "0"}{" "}
                        MAD
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        TVA
                      </div>
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {ride.status === "completed"
                          ? ride.priceCalculation.calculation.balanceTVA
                          : "0"}{" "}
                        MAD
                      </span>
                    </div>
                  </div>
                </CCardBody>
                <CCardHeader className="bg-gradient-primary text-white">
                  <FontAwesomeIcon icon={faComment} className="me-2" />
                  Avis d'utilisateur
                </CCardHeader>
                <CCardBody>
                  <div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Notation
                      </div>
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <FontAwesomeIcon
                            key={index}
                            icon={faStar}
                            color={
                              index < ride.userReview?.rating
                                ? "#FF7722"
                                : "#e4e5e9"
                            }
                          />
                        ))}{" "}
                        {ride.userReview?.rating}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Commentaire :
                      </div>
                      <div
                        className="text-bold"
                        style={{
                          fontSize: "1.1rem",
                          maxHeight: "150px",
                          overflowY: "auto",
                          padding: "5px",
                          width: "100%",
                        }}
                      >
                        {ride.userReview?.comment ? (
                          ride.userReview?.comment
                        ) : (
                          <span
                            style={{ fontStyle: "italic", color: "#6c757d" }}
                          >
                            Aucun commentaire
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </CCardBody>
                <CCardHeader className="bg-gradient-primary text-white">
                  <FontAwesomeIcon icon={faComment} className="me-2" />
                  Avis d'conducteur
                </CCardHeader>
                <CCardBody>
                  <div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Notation
                      </div>
                      <span
                        className="text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        {[...Array(5)].map((_, index) => (
                          <FontAwesomeIcon
                            key={index}
                            icon={faStar}
                            color={
                              index < ride.driverReview?.rating
                                ? "#FF7722"
                                : "#e4e5e9"
                            }
                          />
                        ))}{" "}
                        {ride.driverReview?.rating}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div
                        className="d-flex align-items-center text-bold "
                        style={{ fontSize: "1.1rem" }}
                      >
                        Commentaire :
                      </div>
                      <div
                        className="text-bold"
                        style={{
                          fontSize: "1.1rem",
                          maxHeight: "150px",
                          overflowY: "auto",
                          padding: "5px",
                          width: "100%",
                        }}
                      >
                        {ride.driverReview?.comment ? (
                          ride.driverReview?.comment
                        ) : (
                          <span
                            style={{ fontStyle: "italic", color: "#6c757d" }}
                          >
                            Aucun commentaire
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </CCardBody>
              </CCard>

              {/* Driver Info */}

              <CCard className="mb-4 flex-grow-1" style={{ flex: 1 }}>
                <CCardHeader className="bg-gradient-primary">
                  <div className="d-flex align-items-center text-white">
                    <FontAwesomeIcon icon={faTaxi} className="me-2" />
                    Informations sur le conducteur
                  </div>
                </CCardHeader>

                {!isNotEmpty(ride.driver) ? (
                  <CCardBody style={{ overflow: "hidden" }}>
                    <div className="d-flex justify-content-center">
                      <div className="text-center">
                        <div className="fw-semibold text-center d-flex flex-column justify-content-center align-content-center">
                          Aucun conducteur trouvé
                        </div>
                        <FontAwesomeIcon
                          icon={faUser}
                          className="text-5 custom-icon"
                        />
                      </div>
                    </div>
                  </CCardBody>
                ) : (
                  <CCardBody style={{ overflow: "hidden" }}>
                    <div className="d-flex align-items-center gap-2 mb-3">
                      <div className="rounded-circle">
                        <div className="">
                          <ProfilePictureAvatar
                            profilePicture={ride.driver?.profilePicture}
                            fullName={ride.driver?.fullName}
                            isOnline={ride.driver?.driverProfile?.isOnline}
                            size={50}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="small">
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">Nom:</span>{" "}
                            <Link to={`/drivers/${ride.driver?.id}`}>
                              {ride.driver?.fullName}
                            </Link>
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              E-mail:
                            </span>{" "}
                            {ride.driver?.email}
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              Télephone:
                            </span>{" "}
                            {ride.driver?.phone}
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              Numero de Taxi:
                            </span>{" "}
                            {ride.driver?.driverProfile?.vehicle?.taxiNumber}
                          </div>
                          <div
                            className="mb-2 text-5 font-bold d-flex flex-wrap align-items-center gap-2"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              Matricule:
                            </span>{" "}
                            <MoroccanLicensePlate
                              vehicleNumber={
                                ride.driver?.driverProfile?.vehicle
                                  ?.immatriculation
                              }
                            ></MoroccanLicensePlate>
                            {/* {
                              ride.driver?.driverProfile?.vehicle
                                ?.immatriculation
                            } */}
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              Notation:
                            </span>{" "}
                            <FontAwesomeIcon icon={faStar} color="#FF7722" />{" "}
                            {ride.driver?.rating}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCardBody>
                )}

                <CCardHeader className="bg-gradient-primary text-white">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  Informations sur le passager
                </CCardHeader>

                {!isNotEmpty(ride.user) ? (
                  <CCardBody style={{ overflow: "hidden" }}>
                    <div className="d-flex justify-content-center">
                      <div className="text-center">
                        <div className="fw-semibold text-center d-flex flex-column justify-content-center align-content-center">
                          Le compte utilisateur a été supprimé
                        </div>
                        <FontAwesomeIcon
                          icon={faUserSlash}
                          className="text-5 custom-icon"
                        />
                      </div>
                    </div>
                  </CCardBody>
                ) : (
                  <CCardBody style={{ overflow: "hidden" }}>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="rounded-circle">
                        <div className="">
                          <img
                            src={
                              ride.user?.profilePicture ??
                              `https://ui-avatars.com/api/?name=${ride.user?.fullName} `
                            }
                            alt={ride.user?.fullName?.charAt(0)?.toUpperCase()}
                            className="rounded-circle"
                            width="50"
                            height="50"
                          />
                        </div>
                      </div>
                      <div>
                        <div className="small">
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">Nom:</span>{" "}
                            <Link
                              to={`/users/${ride.user?.id}`}
                              className="` m-0"
                            >
                              {ride.user?.fullName ?? ""}
                            </Link>
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              E-mail:
                            </span>{" "}
                            {ride.user?.email}
                          </div>
                          <div
                            className="mb-2 text-5 font-bold"
                            style={{
                              fontSize: "1rem",
                              whiteSpace: "normal",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <span className="text-medium-emphasis">
                              Télephone:
                            </span>{" "}
                            {ride.user?.phone}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CCardBody>
                )}
              </CCard>

              <CCard className="mb-4 flex-grow-1 max-w-200" style={{ flex: 1 }}>
                <CCardHeader className="bg-gradient-primary">
                  <div className="d-flex align-items-center text-white">
                    <FontAwesomeIcon icon={faComments} className="me-2" />
                    Conversations
                  </div>
                </CCardHeader>

                <div
                  className=" p-2 chats-wrapper-full bg-white scrollbar-custom"
                  style={{ maxHeight: "70vh" }}
                >
                  <ChatUI chats={chats} loading={isLoading} />
                </div>
              </CCard>
            </div>
          </CContainer>
        </BoxWrapper>

        {/* Update Confirmation Modal */}
        <PromptModal
          open={showUpdateConfirm}
          onClose={() => setShowUpdateConfirm(false)}
          onAccept={handleConfirmStatusUpdate}
          message={`Êtes-vous sûr de vouloir changer le statut de ce trajet en "${
            RideStatusLabels[selectedStatus as keyof typeof RideStatusLabels]
          }"?`}
          loading={updateRideMutation.isLoading}
        />
      </section>
    </AdminRoute>
  );
}

const ChatUI = ({
  chats,
  loading,
}: {
  chats: RideConversation[];
  loading: boolean;
}) => {
  const chatEndRef = useRef<HTMLDivElement | null>(null);

  // useEffect(() => {
  //   if (chatEndRef.current) {
  //     chatEndRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }, [chats]);

  const sortedChats = [...chats].sort(
    (a, b) => new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime(),
  );

  if (loading) {
    return (
      <div className="chat-window">
        <div className="d-flex mb-1 justify-content-end">
          <Skeleton height={50} width={130} count={2} />
        </div>
        <div className="d-flex mb-1 justify-content-start">
          <Skeleton height={50} width={130} count={2} />
        </div>
      </div>
    );
  }

  return (
    <div className="chat-window">
      {sortedChats.map((msg, index) => {
        const prevMsg = sortedChats[index - 1];
        const nextMsg = sortedChats[index + 1];
        const isFirstInGroup = !prevMsg || prevMsg.sender !== msg.sender;
        const isLastInGroup = !nextMsg || nextMsg.sender !== msg.sender;

        return (
          <StickyAvatarMessage
            key={msg.id}
            msg={msg}
            index={index}
            isFirstInGroup={isFirstInGroup}
            isLastInGroup={isLastInGroup}
            allMessages={sortedChats}
          />
        );
      })}

      {sortedChats.length === 0 && (
        <div className="fw-semibold text-center d-flex flex-column justify-content-center align-content-center h-full w-full">
          Aucune conversation à afficher
          <div className="text-center">
            <FontAwesomeIcon icon={faComments} className="me-2 custom-icon" />
          </div>
        </div>
      )}
      <div ref={chatEndRef} />
    </div>
  );
};

export default RideDetailsPage;

const StickyAvatarMessage = ({
  msg,
  index,
  isFirstInGroup,
  isLastInGroup,
  allMessages,
}: {
  msg: any;
  index: number;
  isFirstInGroup: boolean;
  isLastInGroup: boolean;
  allMessages: any[];
}) => {
  const messageRef = useRef<HTMLDivElement>(null);
  const [shouldShowAvatar, setShouldShowAvatar] = useState(isLastInGroup);

  useEffect(() => {
    const messageElement = messageRef.current;
    if (!messageElement) return;

    const checkAvatarVisibility = () => {
      const chatContainer = messageElement.closest(".chat-window");
      if (!chatContainer) return;

      const containerRect = chatContainer.getBoundingClientRect();

      // Get all messages from the same sender in this group
      const sameGroupMessages = [];
      let groupStart = index;
      let groupEnd = index;

      // Find group start
      while (
        groupStart > 0 &&
        allMessages[groupStart - 1]?.sender === msg.sender
      ) {
        groupStart--;
      }

      // Find group end
      while (
        groupEnd < allMessages.length - 1 &&
        allMessages[groupEnd + 1]?.sender === msg.sender
      ) {
        groupEnd++;
      }

      // Collect all messages in this group
      for (let i = groupStart; i <= groupEnd; i++) {
        sameGroupMessages.push(i);
      }

      // Find the last fully visible message in this group
      let lastVisibleIndex = -1;
      for (let i = sameGroupMessages.length - 1; i >= 0; i--) {
        const msgIndex = sameGroupMessages[i];
        const msgElement = chatContainer.querySelector(
          `[data-message-index="${msgIndex}"]`,
        );

        if (msgElement) {
          const msgRect = msgElement.getBoundingClientRect();
          const isFullyVisible =
            msgRect.top >= containerRect.top &&
            msgRect.bottom <= containerRect.bottom;

          if (isFullyVisible) {
            lastVisibleIndex = msgIndex;
            break;
          }
        }
      }

      // Show avatar only on the last visible message in the group
      setShouldShowAvatar(lastVisibleIndex === index);
    };

    // Initial check
    checkAvatarVisibility();

    // Listen for scroll events
    const chatContainer = messageElement.closest(".chat-window");
    if (chatContainer) {
      chatContainer.addEventListener("scroll", checkAvatarVisibility);

      return () => {
        chatContainer.removeEventListener("scroll", checkAvatarVisibility);
      };
    }
  }, [index, msg.sender, allMessages]);

  return (
    <div
      ref={messageRef}
      data-message-index={index}
      className={`d-flex mb-1 message-row ${
        msg.sender === "user" ? "justify-content-end" : "justify-content-start"
      }`}
    >
      {msg.sender === "driver" && (
        <div className="me-2" style={{ width: "30px", height: "30px" }}>
          {shouldShowAvatar && (
            <img
              src={
                msg.driver?.profilePicture ??
                `https://ui-avatars.com/api/?name=${msg.driver?.fullName}`
              }
              alt={msg.driver?.fullName?.charAt(0)?.toUpperCase()}
              className="rounded-circle"
              width="30"
              height="30"
              style={{
                transition: "all 0.3s ease",
              }}
            />
          )}
        </div>
      )}

      <div
        className={`p-3 modern-chat-bubble ${
          msg.sender === "user"
            ? "bg-primary-chat user-bubble"
            : "bg-light-chat driver-bubble"
        } ${isFirstInGroup ? "first-in-group" : ""} ${isLastInGroup ? "last-in-group" : ""}`}
      >
        <p className="mb-1">{msg.data}</p>
        <div className="d-flex justify-content-between align-items-center gap-3">
          <div>
            {msg.isSystem && (
              <small className="text-muted d-flex gap-1 justify-content-between align-items-center">
                <FontAwesomeIcon icon={faRobot} color="#FF7722" />
                <span>Automatique</span>
              </small>
            )}
          </div>
          <small className="text-muted d-flex justify-content-between align-items-center gap-2">
            {format(new Date(msg.dateTime), "HH:mm")}{" "}
            {msg.sender === "driver" && (
              <>
                {msg.isSeen ? (
                  <FontAwesomeIcon icon={faCheckDouble} color="#FF7722" />
                ) : (
                  <FontAwesomeIcon icon={faCheck} />
                )}
              </>
            )}
            {msg.sender === "user" && (
              <>
                {msg.isSeen ? (
                  <FontAwesomeIcon icon={faCheckDouble} color="#FF7722" />
                ) : (
                  <FontAwesomeIcon icon={faCheck} />
                )}
              </>
            )}
          </small>
        </div>
      </div>

      {msg.sender === "user" && (
        <div className="ms-2" style={{ width: "30px", height: "30px" }}>
          {shouldShowAvatar && (
            <img
              src={
                msg.user?.profilePicture ??
                `https://ui-avatars.com/api/?name=${msg.user?.fullName}`
              }
              alt={msg.user?.fullName?.charAt(0)?.toUpperCase()}
              className="rounded-circle"
              width="30"
              height="30"
              style={{
                transition: "all 0.3s ease",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
